module.exports = __webpack_public_path__ + "img/product_39.00fc8ec.webp";